<template>
  <swiper class="insta-gallery mySwiper" :options="swiperOption" ref="mySwiper">
    <swiper-slide v-for='(src, key) in post.gallerySrc' :key="key">
      <img class="preview swiper" :src="src" />
      <!-- <img class="preview swiper" :src="item.node.display_resources[0].src" /> -->
    </swiper-slide>
    <!-- Optional controls -->
    <div class="swiper-button-prev" slot="button-prev"><img src="~images/project/previous.svg" /></div>
    <div class="swiper-button-next" slot="button-next"><img src="~images/project/next.svg" /></div>
    <div class="swiper-pagination" slot="pagination"></div>
    <div class="album-icon"><img src="~images/project/album.svg" /></div>
  </swiper>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import {swiper, swiperSlide} from 'vue-awesome-swiper'
export default {
  props: ['post'],
  components: {swiper, swiperSlide},
  data () {
    return {
      swiperOption: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true
        },
        lazy: true,
        spaceBetween: 0,
        keyboard: true
      }
    }
  },
  mounted () {
    const img = this.$el.querySelector('img.preview')

    const onloadFunc = () => {
      setTimeout(() => {
        this.$parent.$el.querySelector('.text-content').style.width = img.width + 'px'
        this.$el.style.width = img.width + 'px'
        // this.$refs.mySwiper.$swiper.update()
        this.$refs.mySwiper.swiper.update()
      })
    }

    img.onload = function () {
      onloadFunc()
    }

    if (img.complete) {
      onloadFunc()
    }
  }
}
</script>

<style lang="scss">
.insta-gallery {
  .swiper-button-prev,
  .swiper-button-next {
    background-image: none;

    // img {
    //   position: absolute;
    //   width: 100%;
    // }
    // &::after {
    //   content: '';
    // }
  }

  .swiper-pagination .swiper-pagination-bullet-active {
    background: #333;
  }
  .album-icon {
    position: absolute;
    top: 10px;
    right: 10px;
    font-weight: bold;
    color: #FFF;
    z-index: 1;
    width: 25px;
  }
  .album-nav {
    .dots {
      &.active {
        font-weight: bold;
        font-size: 1.1em;
      }
    }
  }
}
</style>
